<template>
    <div>
        <hts-modal
            :show="openModal"
            size="medium"
            :title="$t('labels.addWaitingTask')"
            @hide="hide">
            <hts-form
                class="space-y-6 mt-5"
                @submit="saveWaitingTask">
                <div
                    v-for="(waitingTask, index) in waitingTasks"
                    :key="index"
                    class="grid grid-cols-10 gap-3">
                    <hts-form-select
                        v-model="waitingTask.index"
                        v-model:text="waitingTask.name"
                        class="col-span-3"
                        :label="$t('labels.position')"
                        :items="positionItemSelect"
                        key-id="index"
                        key-label="namePosition"
                        required
                        name="position"
                        :prop="`position_${index}`"
                        @change="(val: any) => handleSelectPosition(val, index)" />

                    <hts-form-select
                        v-model="waitingTask.task"
                        v-model:text="waitingTask.taskName"
                        :label="$t('labels.afterTask')"
                        :items="waitingTask.position?.tasks || []"
                        key-id="task"
                        name="task"
                        :prop="`task_${index}`"
                        key-label="taskName"
                        class="col-span-3">
                        <template #custom>
                            <hts-tooltip class="ml-1">
                                <span class="font-bold">
                                    Nếu để trống, tác vụ chờ được thêm mặc định là tác vụ đầu tiên tại vị trí đã chọn
                                </span>

                                <template #reference>
                                    <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                </template>
                            </hts-tooltip>
                        </template>
                    </hts-form-select>

                    <hts-form-input
                        v-model="waitingTask.timeComplete"
                        class="col-span-3"
                        :label="$t('labels.waitTaskTimeComplete')"
                        required
                        name="waitTaskTimeComplete"
                        type="number"
                        :prop="`waitTaskTimeComplete_${index}`" />

                    <div class="w-full h-full flex justify-center items-center">
                        <hi-x-circle-icon
                            class="h-6 w-6 mt-8 text-error-500 hover:text-error-700 cursor-pointer"
                            @click="($event: any) => deleteWaitingTask($event, index)" />
                    </div>
                </div>

                <hts-form-button
                    class="mt-5"
                    icon-name="hi-plus-icon"
                    icon-position="left"
                    color="info"
                    size="small"
                    type="button"
                    :outline="false"
                    @click="addWaitingTask">
                    {{ $t('labels.add') }}
                </hts-form-button>

                <div class="flex justify-end mt-5 gap-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        type="submit"
                        color="info"
                        :outline="false">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>
    </div>
</template>
<script setup lang="ts">
import { $lodash } from '#imports'
const { $formatters } = useNuxtApp()
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['update'])

const disabled = toRefs(props)
const openModal = ref(false)

const defaultWaitingTask = {
  index: '',
  name: '',
  task: '',
  taskName: '',
  timeComplete: null,
  type: 'waiting',
  position: {} as { [key: string]: any },
  _id: 1
}

const createDefaultWaitingTask = () => {
  return $lodash.cloneDeep({
    ...defaultWaitingTask,
    _id: $formatters.generateId()
  })
}

const waitingTasks = ref<{ [key: string]: any }[]>([])
const positions = ref<{ [key: string]: any }[]>([])

const open = (waitingTaskVal: { [key: string]: any }[], positionsVal: { [key: string]: any }[]) => {
  waitingTasks.value = waitingTaskVal?.length ? $lodash.cloneDeep(waitingTaskVal) : [createDefaultWaitingTask()]
  positions.value = $lodash.cloneDeep(positionsVal)
  openModal.value = true
}

const positionItemSelect = computed(() => {
  return positions.value.map((position) => {
    const namePosition = `Vị trí ${position.index} - ${position.nodeLocationName}`

    return { index: position.index, namePosition, position }
  })
})

const addWaitingTask = () => {
  if (!waitingTasks.value.length) {
    resetField()
    return
  }

  waitingTasks.value.push($lodash.cloneDeep(createDefaultWaitingTask()))
}

const deleteWaitingTask = (e: Event, index: number) => {
  e.preventDefault()
  e.stopPropagation()

  if (!waitingTasks.value[index]) {
    return
  }
  waitingTasks.value.splice(index, 1)
}

const handleSelectPosition = (positions: { [key: string]: any }[], index: number) => {
  if (!waitingTasks.value || !waitingTasks.value.length) {
    resetField()
    return
  }

  if (!waitingTasks.value[index]) {
    return
  }

  waitingTasks.value[index].position = positions?.[0]?.position || {}
  waitingTasks.value[index].task = ''
  waitingTasks.value[index].taskName = ''
}

const resetField = () => {
  waitingTasks.value = [$lodash.cloneDeep(createDefaultWaitingTask())]
}

const hide = () => {
  openModal.value = false
}

const saveWaitingTask = () => {
  hide()
  emits('update', $lodash.cloneDeep(waitingTasks.value))
  resetField()
}

defineExpose({ open, hide })
</script>
